import React from "react";
import Reveal from "./Reveal";

const TYPES = [
  { name: "T-Shirts", image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&q=70&auto=format&fit=crop" },
  { name: "Denim & Jeans", image: "https://images.unsplash.com/photo-1542272604-787c3835535d?w=400&q=70&auto=format&fit=crop" },
  { name: "Jackets", image: "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=400&q=70&auto=format&fit=crop" },
  { name: "Dresses", image: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400&q=70&auto=format&fit=crop" },
  { name: "Activewear", image: "https://images.unsplash.com/photo-1483721310020-03333e577078?w=400&q=70&auto=format&fit=crop" },
  { name: "Ethnic Wear", image: "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=400&q=70&auto=format&fit=crop" },
];

export function ClothingTypes() {
  return (
    <section aria-labelledby="clothing-types-heading" className="py-24 px-6 md:px-10" style={{ background: "#14171C" }}>
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <p className="uppercase tracking-widest text-xs mb-3" style={{ fontFamily: "'JetBrains Mono', monospace", color: "#FF8A00" }}>
            Browse By Type
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 id="clothing-types-heading" style={{ fontFamily: "Fraunces, serif", color: "#F5F1EA" }} className="text-4xl md:text-5xl mb-14">
            Shop by clothing type
          </h2>
        </Reveal>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-5">
          {TYPES.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.06}>
              <a href="#shop" className="group flex flex-col items-center gap-3 text-center">
                <span
                  className="block w-24 h-24 md:w-28 md:h-28 rounded-full overflow-hidden transition-transform duration-300 group-hover:scale-105"
                  style={{ border: "2px solid rgba(255,255,255,0.1)" }}
                >
                  <img
                    src={t.image}
                    alt={t.name}
                    loading="lazy"
                    className="w-full h-full"
                    style={{ objectFit: "cover" }}
                  />
                </span>
                <span className="text-sm" style={{ color: "#F5F1EA", opacity: 0.85 }}>{t.name}</span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ClothingTypes;
